import { environment } from '@/config'

export const HEADER_COLOR = environment === 'production' ? 'primary' : 'red'
